import * as React from 'react';

import { cn } from '@/lib/utils';

export const PageActions = ({ className, children, ...props }: React.ComponentProps<'div'>) => {
    return (
        <div data-slot="page-actions" className={cn('flex shrink-0 items-center gap-2', className)} {...props}>
            {children}
        </div>
    );
};
